import { useState } from 'react';
import { Form } from 'react-bootstrap';

import { clickElement } from 'src/services/utils';

const InvoiceXml = ({
  invoiceXml,
  uploadDocument,
  setStateICMSST,
  handleSetInvoiceXml,
}) => {
  const [nfXml, setNfXml] = useState(invoiceXml);

  const fileUpload = e => {
    uploadDocument({
      file: e.target.files[0],
      documentType: 'NF_XML',
    }).then(file => {
      setNfXml(file);
      setStateICMSST(file.icsmST);
      handleSetInvoiceXml();
    });
  };

  return (
    <div className="col-12 col-lg-6 ">
      {nfXml && (
        <>
          <a
            target="_blank"
            href={nfXml?.documentURL || '#'}
            className="mr-3 text-nowrap input-files-name"
            rel="noreferrer"
          >
            <i className="fa fa-check d-inline" aria-hidden="true" />
            {nfXml.documentURL}
          </a>
        </>
      )}
      <Form>
        <Form.Group>
          <button
            className="input-add2 w-100"
            type="button"
            onClick={() => clickElement('#inputXML')}
          >
            <span>{nfXml ? 'Alterar' : 'Adicionar'} arquivo XML</span>
          </button>
          <Form.Control
            className="d-none"
            name="inputXML"
            id="inputXML"
            type="file"
            accept=".xml"
            onChange={fileUpload}
          />
        </Form.Group>
      </Form>
    </div>
  );
};

export default InvoiceXml;
